<span class="cat-title">Categories<span  class="picked" *ngIf="categoriesPicked.length > 0"> - includes<span *ngFor="let picked of categoriesPicked"> - {{picked}} </span></span></span>
<ul class="nav nav-fill justify-content-center">
  <li class="nav-item c-blue p-3 text-uppercase" *ngFor="let cat of categories">
    <app-category-link [cat]="cat"  (categoryPicked)="categoryClicked($event)"></app-category-link>
  </li>
</ul>
